import * as React from 'react';
import classnames from 'classnames';

import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';

import './more-button.scss';

type Props = {
  width: number,
  height: number,
  iconWidth?: number,
  iconHeight?: number,
  customColor?: 'white' | 'grey',
  className?: string,
  disabled?: boolean,
  onClick: (event?: React.MouseEvent) => void
};

class MoreButton extends React.PureComponent<Props> {
  static defaultProps = {
    width: 40,
    customColor: 'grey'
  };

  render() {
    const { width, height, onClick, iconWidth, iconHeight, disabled, customColor, className } = this.props;

    const buttonClasses = classnames('more-button', className, {
      'more-button--disabled': disabled
    });

    return (
      <button
        type="button"
        className={buttonClasses}
        onClick={!disabled ? onClick : undefined}
        style={{
          height,
          width
        }}
      >
        <SVGDynamicIcon
          name="three-dots-vertical-custom-fg"
          customColor={customColor}
          clickable
          disabled={disabled}
          width={iconWidth || 4}
          height={iconHeight || 16}
        />
      </button>
    );
  }
}

export default MoreButton;
